import correct from '@/assets/img/documents/house-hold/drying-report-correct.jpg';
import wrong from '@/assets/img/documents/house-hold/drying-report-wrong.jpg';

import Card from '@/components/Card';
import { Uploader } from '@/components/ui/Uploader/Uploader';
import { ATTACHMENT_TYPES } from '@/consts';

import { useLingui } from '@lingui/react';

export const DRYING_REPORT_NAME = 'drying_report';

const DryingReport = () => {
  const { i18n } = useLingui();

  const instructionProps = {
    title: i18n.t('Jak poprawnie dodać zgłoszenie osuszania?'),
    steps: [
      i18n.t('Upewnij się, że wszystkie dane dotyczące osuszania są widoczne.'),
      i18n.t('Sprawdź, czy załączasz wszystkie strony dokumentu.'),
      i18n.t('Jeśli przesyłasz zdjęcia – sprawdź, czy dokument jest czytelny.'),
      i18n.t('Jeśli plik jest zabezpieczony – dołącz hasło.'),
    ],
    correctImg: correct,
    wrongImg: wrong,
  };

  return (
    <Card>
      <Uploader
        title={i18n.t('Zgłoszenie osuszania')}
        instructionProps={instructionProps}
        inputFieldName={DRYING_REPORT_NAME}
        attachmentTypeId={ATTACHMENT_TYPES.ZLECENIE_USLUGI_OSUSZANIA}
        data-testid={`${DRYING_REPORT_NAME}-uploader`}
      />
    </Card>
  );
};

export default DryingReport;
